import config from 'services/table/const';

import {
  formatDate,
  isValidDate,
} from 'utilities/common';
import * as Pin from 'react-icons/ri';
import LocationTooltips from 'ui/components/data/location';

let table = { ...config };
table.url = '/tms/delivery/distribution';
table.filter = {document_status: 'new'}
table.columns = {
  order_code: {
    title: 'Kode',
    sortable: true,
    alias: 'created_at',
    width: 80,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold">
            {row?.code}
          </div>
          {row?.ref_code && (
            <small className="info">REF: {row?.ref_code}</small>
          )}
        </div>
      );
    },
  },
  customer: {
    title: 'Customer',
    sortable: true,
    alias: 'customer.name',
    width: 80,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.customer?.name}
          </div>
        </div>
      );
    },
  },
  iconss: {
    title: '',
    sortable: false,
    width: 20,
    class: 'text-center',
    component: (row) => {
      return (
        <div className="table-col">
          <Pin.RiMapPin2Fill color="gray" size={25} />
        </div>
      );
    },
  },
  pickup_address: {
    title: 'Origin',
    sortable: false,
    alias: 'pickup_address.name',
    width: 120,
    component: (row) => {
      return (
        <LocationTooltips data={row?.pickup_address}>
          <div className="row">
            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
              {row?.pickup_address?.name}
            </div>
            {isValidDate(row?.etd_at) && (
              <small className="info text-uppercase">
                ETD: {formatDate(row?.etd_at)}
              </small>
            )}
          </div>
        </LocationTooltips>
      );
    },
  },
  icons: {
    title: '',
    sortable: false,
    width: 20,
    class: 'text-center',
    component: (row) => {
      return (
        <div className="table-col">
          <Pin.RiMapPin2Fill color="gray" size={25} />
        </div>
      );
    },
  },
  recipient: {
    title: 'Destination',
    sortable: false,
    alias: 'recipient.name',
    width: 120,
    component: (row) => {
      return (
        <LocationTooltips data={row?.recipient}>
          <div className="row">
            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
              {row?.recipient?.name}
            </div>
            <small className="info text-uppercase">
              ETA: {formatDate(row?.eta_at)}
            </small>
          </div>
        </LocationTooltips>
      );
    },
  },

  cod_value: {
    title: 'COD',
    format_number: true,
    sortable: false,
    width: 70,
    class: 'text-end',
    classHeader: 'text-end',
  },

  created_at: {
    title: 'Dibuat Tanggal',
    width: 80,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-9 fw-semibold text-uppercase">
            {formatDate(row?.created_at)}
          </div>
        </div>
      );
    },
  },
};

export default table;
